import { createContext } from 'react'
import { ILoggedInUser } from 'types'

export type UserContextProps = {
    refreshUser?: () => Promise<ILoggedInUser | null | undefined>
    setAuthenticatedUser?: (user: ILoggedInUser | null | undefined) => void
    user?: ILoggedInUser | null | undefined
    hasFetchedUser: boolean
    taggerApiKey?: string
}

const UserContext = createContext({
    user: {} as ILoggedInUser,
    hasFetchedUser: false,
    taggerApiKey: '',
    refreshUser: async () => undefined,
    setAuthenticatedUser: () => undefined,
} as UserContextProps)

export default UserContext
